import { EnumService } from "./../../../shared/services/enum.service";
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { ProductService } from "src/app/components/shared/services/product.service";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { Product, ColorFilter } from "src/app/modals/product.model";
import { FormBuilder, FormGroup } from "@angular/forms";
import { constApi } from "src/environments/constApi";
import { NgxSpinnerService } from "ngx-spinner";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EcommerceNpService } from "src/app/components/shared/services/ecommerce-np.service";
@Component({
  selector: "app-product-left-sidebar",
  templateUrl: "./product-left-sidebar.component.html",
  styleUrls: ["./product-left-sidebar.component.sass"],
})
export class ProductLeftSidebarComponent implements OnInit {
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  public sidenavOpen: boolean = true;
  public animation: any; // Animation
  public sortByOrder: string = ""; // sorting
  public page;
  public tagsFilters: any[] = [];
  public viewType: string = "grid";
  public viewCol: number = 25;
  public colorFilters: ColorFilter[] = [];

  public items: Product[] = [];
  public allItems: Product[] = [];
  public products: Product[] = [];
  public tags: any[] = [];
  public colors: any[] = [];
  public brands: any[] = [];
  public Procesadores: any[] = [];
  public Almacenamiento: any[] = [];
  public Pulgadas: any[] = [];
  public PulgadasM: any[] = [];
  public tarjetasVideo: any[] = [];
  public paramNomItem: any = {
    param1: "",
    param2: "",
    param3: "",
  };

  public MRam: any[] = [];
  public priceMin: number;
  public priceMax: number;
  public priceIni: number;
  public priceFin: number;
  public step: number = 100;
  esMovil: boolean = false;
  fbRangoDias: FormGroup;
  category: any;
  marcaSession: any = "";
  tituloPage: any = "";
  marca: any = "";
  criterio: any;
  mensajeResultado: string = "Cargando Resultados";
  ordenItems: any = "Clic";
  estGamer: boolean = false;
  ckTodAlmacena: boolean = true;
  ckTodFl: boolean = true;
  ckTodCat: boolean = true;
  ckTodosProce: boolean = true;
  ckTodsGamer: boolean = true;
  ckTodosPulg: boolean = true;
  ckTodosRam: boolean = true;
  ckTodosTarjV: boolean = true;
  urllast: any = "";
  ////
  mostrarFilial: boolean = false;
  categoryParam: any;
  criterioParam: any;
  gamerParam: any;
  marcaParam: any;
  procesadorParam: any;
  almacenamientoParam: any;
  nombreItem: any;
  paramSearch: any[] = [];
  categorias: any[] = [];
  catFilter: any[] = [];
  filiales: any[] = [];
  Filial: any;
  categoryFilterName: "";
  categoryFilterCod: "";
  public subscriber: Subscription;
  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private enumService: EnumService,
    private spinner: NgxSpinnerService,
    private _location: Location,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private ecomService: EcommerceNpService
  ) {}
  public getTags(products) {
    var uniqueBrands = [];
    var itemBrand = Array();
    products.map((product, index) => {
      if (product.tags) {
        product.tags.map((tag) => {
          const index = uniqueBrands.indexOf(tag);
          if (index === -1) uniqueBrands.push(tag);
        });
      }
    });
    for (var i = 0; i < uniqueBrands.length; i++) {
      itemBrand.push({ brand: uniqueBrands[i] });
    }
    this.tags = itemBrand;
  }

  async ngOnInit() {
    this.buildForm();
    this.Inicializar();
    this.route.params.subscribe(async (params: any) => {
      this.route.queryParams.subscribe(async (query: any) => {
        this.Filial = query.Tienda;
        this.cargarInfoProduct();
      });
    });
  }
  async Inicializar() {
    this.categoryParam = this.activateRoute.snapshot.params["category"];
    this.criterioParam = this.activateRoute.snapshot.params["criterio"];
    this.gamerParam = this.activateRoute.snapshot.params["gamer"];
    this.marcaParam = this.activateRoute.snapshot.params["marca"];
    this.procesadorParam = this.activateRoute.snapshot.params["procesador"];
    this.almacenamientoParam =
      this.activateRoute.snapshot.params["almacenamiento"];
    this.nombreItem =
      (this.gamerParam == 0 ? "" : this.gamerParam) +
      " " +
      (this.procesadorParam == 0 ? "" : this.procesadorParam) +
      " " +
      (this.almacenamientoParam == 0 ? "" : this.almacenamientoParam);
    if (isNaN(this.criterioParam)) {
      this.nombreItem = this.criterioParam;
    }
    if (isNaN(this.criterioParam) || this.criterioParam == 0) {
      this.paramSearch = [
        { clave: "Codigo", valor: this.categoryParam },
        {
          clave: "Marca",
          valor: this.marcaParam == "TODAS" ? "" : this.marcaParam,
        },
        { clave: "NombreItm", valor: this.nombreItem },
        { clave: "Orden", valor: this.ordenItems },
        { clave: "TItemEC", valor: "ITM" },
        { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
      ];
    } else {
      this.paramSearch = [
        { clave: "Codigo", valor: this.categoryParam },
        {
          clave: "Marca",
          valor: this.marcaParam == "TODAS" ? "" : this.marcaParam,
        },
        { clave: "NombreItm", valor: this.nombreItem },
        { clave: "Orden", valor: this.ordenItems },
        { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
      ];
    }

    let paramPro = [{ clave: "tipo", valor: "PROCE" }];
    let resProce: any = await this.obtenerEnum(paramPro);
    if (resProce != undefined) {
      this.Procesadores = resProce.body;
    }
    let paramAlma = [{ clave: "tipo", valor: "ALMACE" }];
    let resAlma: any = await this.obtenerEnum(paramAlma);
    if (resAlma != undefined) {
      this.Almacenamiento = resAlma.body;
    }
    let paramRam = [{ clave: "tipo", valor: "MRAM" }];
    let resRam: any = await this.obtenerEnum(paramRam);
    if (resRam != undefined) {
      this.MRam = resRam.body;
    }
    let paramCAT = [{ clave: "tipo", valor: "CATGAMER" }];
    let resCatGamer: any = await this.obtenerEnum(paramCAT);
    if (resCatGamer != undefined) {
      this.categorias = resCatGamer.body;
    }
    let paramTARJ = [{ clave: "tipo", valor: "TRJV" }];
    let resTarj: any = await this.obtenerEnum(paramTARJ);
    if (resTarj != undefined) {
      this.tarjetasVideo = resTarj.body;
    }
    let resFilial: any = await this.obtenerFiliales().then((x) => x.body);
    if (resFilial != undefined) {
      this.filiales = resFilial.filter((x) => x.Filial != "NP");
    }
    if (this.categoryParam.length == 3) {
      let paramCat = [{ clave: "Codigo", valor: this.categoryParam }];
      let catalogoFilter = await this.obtenerCatalogo(paramCat).then((x) =>
        x.body.filter((x) => x.Habilitado == true)
      );
      this.catFilter = catalogoFilter;
      let itemPrin = {
        Codigo: this.categoryParam,
        DenoCat: "Todos",
        Clase: catalogoFilter[0].Clase,
      };
      this.catFilter.push(itemPrin);
      sessionStorage.setItem("catPrin", JSON.stringify(this.catFilter));
      this.categoryFilterName = this.catFilter[0].Clase;
      this.categoryFilterCod = this.categoryParam;
      sessionStorage.setItem(
        "categoriaPrin",
        JSON.stringify(this.categoryFilterCod)
      );
      let item = this.catFilter.find((x) => x.Codigo == this.categoryParam);
      if (item != undefined) {
        item.checked = true;
      }
    } else {
      if (sessionStorage.getItem("catPrin") != null) {
        let data = JSON.parse(sessionStorage.getItem("catPrin"));
        this.categoryFilterCod = JSON.parse(
          sessionStorage.getItem("categoriaPrin")
        );
        this.catFilter = [];
        this.catFilter = data;
        this.categoryFilterName = this.catFilter[0].Clase;
        let item = this.catFilter.find((x) => x.Codigo == this.categoryParam);
        if (item != undefined) {
          item.checked = true;
        }
      }
    }
    this.cargarCombos();
  }
  cargarCombos() {
    if (this.brands.length > 0) {
      if (this.marcaParam != "0") {
        let i = this.brands.findIndex((x) => x.Marca == this.marcaParam);
        if (i != -1) {
          this.brands[i].checked = true;
        } else {
          this.brands[0].checked = true;
        }
      }
    }
    if (this.gamerParam == "0") {
      this.ckTodsGamer = true;
      this.estGamer = false;
    } else {
      this.estGamer = true;
      this.ckTodsGamer = false;
    }
    if (this.Almacenamiento.length > 0) {
      if (this.almacenamientoParam != "0") {
        let i = this.Almacenamiento.findIndex(
          (x) => x.Codigo == this.almacenamientoParam
        );
        if (i != -1) {
          this.Almacenamiento[i].checked = true;
        }
        this.ckTodAlmacena = false;
      } else {
        this.ckTodAlmacena = true;
      }
    }
    if (this.categorias.length > 0) {
      if (this.categoryParam != "0") {
        let i = this.categorias.findIndex(
          (x) => x.Codigo == this.categoryParam
        );
        if (i != -1) {
          this.categorias[i].checked = true;
        }
        this.ckTodCat = false;
      } else {
        this.ckTodCat = true;
      }
    }
    if (this.Procesadores.length > 0) {
      if (this.procesadorParam != "0") {
        let i = this.Procesadores.findIndex(
          (x) => x.Codigo == this.procesadorParam
        );
        if (i != -1) {
          this.Procesadores[i].checked = true;
        }
        this.ckTodosProce = false;
      } else {
        this.ckTodosProce = true;
      }
    }
    if (this.tarjetasVideo.length > 0) {
      if (this.criterioParam != "0") {
        let i = this.tarjetasVideo.findIndex(
          (x) => x.Codigo == this.criterioParam
        );
        if (i != -1) {
          this.tarjetasVideo[i].checked = true;
        } else {
          this.ckTodosTarjV = true;
        }
        this.ckTodosTarjV = false;
      } else {
        this.ckTodosTarjV = true;
      }
    }
  }
  ngOnDestroy() {
    this.subscriber?.unsubscribe();
  }
  async cargarInfoProduct() {
    this.mensajeResultado = "Cargando Resultados";
    this.categoryParam = this.activateRoute.snapshot.params["category"];
    this.criterioParam = this.activateRoute.snapshot.params["criterio"];
    this.gamerParam = this.activateRoute.snapshot.params["gamer"];
    this.marcaParam = this.activateRoute.snapshot.params["marca"];
    this.procesadorParam = this.activateRoute.snapshot.params["procesador"];
    this.almacenamientoParam =
      this.activateRoute.snapshot.params["almacenamiento"];
    this.page = this.activateRoute.snapshot.params["page"];
    this.allItems.splice(0, this.allItems.length);
    this.products.splice(0, this.products.length);
    this.nombreItem =
      (this.gamerParam == 0 ? "" : this.gamerParam) +
      " " +
      (this.procesadorParam == 0 ? "" : this.procesadorParam) +
      " " +
      (this.almacenamientoParam == 0 ? "" : this.almacenamientoParam);
    if (isNaN(this.criterioParam)) {
      this.nombreItem = this.criterioParam;
    }
    if (isNaN(this.criterioParam) || this.criterioParam == 0) {
      this.paramSearch = [
        { clave: "Codigo", valor: this.categoryParam },
        {
          clave: "Marca",
          valor: this.marcaParam == "TODAS" ? "" : this.marcaParam,
        },
        { clave: "NombreItm", valor: this.nombreItem },
        { clave: "Orden", valor: this.ordenItems },
        { clave: "TItemEC", valor: "ITM" },
        { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
      ];
    } else {
      this.paramSearch = [
        { clave: "CodigoBarras", valor: this.criterioParam },
        { clave: "Orden", valor: this.ordenItems },
        { clave: "TItemEC", valor: "ITM" },
        { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
      ];
    }
    this.onPageChanged(this.page);
    this.cargarCombos();
    let paramPug: any;
    if (this.categoryParam == "AEQ16" || this.categoryParam == "AEQ05") {
      switch (this.categoryParam) {
        case "AEQ16":
          paramPug = [{ clave: "tipo", valor: "PUGM" }];
          break;
        case "AEQ05":
          paramPug = [{ clave: "tipo", valor: "PUG" }];
          break;
      }
      let resPug: any = await this.obtenerEnum(paramPug);
      if (resPug != undefined) {
        this.Pulgadas = resPug.body;
      }
    }
    if (this.Filial == undefined) {
      this.mostrarFilial = false;
    } else {
      this.mostrarFilial = true;
    }
    this.productService
      .getProductbyparam(this.paramSearch)
      .subscribe((Product) => {
        // console.log(Product)
        this.allItems =
          this.Filial == 0 ? Product.filter((x) => x.Filial != "NP") : Product;
        this.products =
          this.Filial == 0 ? Product.filter((x) => x.Filial != "NP") : Product;

        this.obtenerPrecioMaximo();
      });
    let resMarcas: any = await this.obtenerMarcas(this.paramSearch);

    let paramCat = [{ clave: "Codigo", valor: this.categoryParam == "0" ? "%" : this.categoryParam }];
    let resCat: any = await this.obtenerCatalogo(paramCat).then(
      (x) => x.body[0]
    );
    // this.catFilter = resCat
    this.tituloPage = "";
    if (resCat != undefined) {
      this.enumService.setTitleMeta(
        this.categoryParam.length <= 3
          ? resCat.Clase
          : resCat.DenoCat + " | Novaplaza",
        {
          name: "description",
          content:
            "Ofrecemos las mejores " +
            resCat.DenoCat +
            " al mejor precio en Arequipa",
        }
      );
      this.tituloPage =
        this.categoryParam.length <= 3 ? resCat.Clase : resCat.DenoCat;
    } else {
      if (this.gamerParam != 0) {
        this.enumService.setTitleMeta("Zona Gamer | Novaplaza", {
          name: "description",
          content:
            "Ofrecemos las mejores componentes para tu zona gamer en Arequipa",
        });
        this.tituloPage = "Zona Gamer";
      }
    }
    if (resMarcas != undefined) {
      this.cargarArrayMarcas(resMarcas);
    }
    setTimeout(() => {
      if (this.allItems.length == 0) {
        this.mensajeResultado = "Sin Resultados";
        this.spinner.hide();
      }
    }, 3000);
  }
  ngDoCheck() {
    let tamaño = window.innerWidth;
    if (tamaño <= 600) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }
  cargarData() {}
  cargarMarcas(param) {}
  buildForm() {
    this.fbRangoDias = this.fb.group({
      priceMin: [0],
      priceMax: [0],
    });
  }

  public changeViewType(viewType, viewCol) {
    this.viewType = viewType;
    this.viewCol = viewCol;
  }
  // Animation Effect fadeIn
  public fadeIn() {
    this.animation = "fadeIn";
  }

  // Animation Effect fadeOut
  public fadeOut() {
    this.animation = "fadeOut";
  }

  // Update tags filter
  public updateTagFilters(tags: any[]) {
    this.tagsFilters = tags;
    this.animation == "fadeOut" ? this.fadeIn() : this.fadeOut(); // animation
  }

  // sorting type ASC / DESC / A-Z / Z-A etc.
  public onChangeSorting(val) {
    this.sortByOrder = val;
    this.ordenItems = val;
    this.animation == "fadeOut" ? this.fadeIn() : this.fadeOut(); // animation
    if (val == "Stock") {
      this.allItems.sort(function (a, b) {
        return b.SaldoG - a.SaldoG;
      });
    } else {
      if (isNaN(this.criterioParam) || this.criterioParam == 0) {
        this.paramSearch = [
          { clave: "Codigo", valor: this.categoryParam },
          {
            clave: "Marca",
            valor: this.marcaParam == "TODAS" ? "" : this.marcaParam,
          },
          { clave: "NombreItm", valor: this.nombreItem },
          { clave: "Orden", valor: this.ordenItems },
          { clave: "TItemEC", valor: "ITM" },
          { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
        ];
      } else {
        this.paramSearch = [
          { clave: "CodigoBarras", valor: this.criterioParam },
          { clave: "Orden", valor: this.ordenItems },
          { clave: "TItemEC", valor: "ITM" },
          { clave: "Filial", valor: isNaN(this.Filial) ? this.Filial : "" },
        ];
      }
      this.onBrendsChangedProc(this.paramSearch);
    }
  }
  // Initialize filetr Items
  public filterItems(): Product[] {
    return this.items.filter((item: Product) => {
      const Colors: boolean = this.colorFilters.reduce((prev, curr) => {
        // Match Color
        if (item.colors) {
          if (item.colors.includes(curr.color)) {
            return prev && true;
          }
        }
      }, true);
      const Tags: boolean = this.tagsFilters.reduce((prev, curr) => {
        // Match Tags
        if (item.tags) {
          if (item.tags.includes(curr)) {
            return prev && true;
          }
        }
      }, true);
      return Colors && Tags; // return true
    });
  }
  public onPageChanged(event) {
    this.page = event;
    this.router.navigate(
      [
        "/home/products/",
        this.categoryParam,
        this.criterioParam,
        this.gamerParam,
        this.marcaParam,
        this.procesadorParam,
        this.almacenamientoParam,
        this.page,
      ],
      {
        queryParams: { Tienda: this.Filial },
      }
    );
    this.scrollTop();
  }

  public updatePriceFiltersMin() {
    this.priceMin = this.fbRangoDias.get("priceMin").value;
    this.priceMax = this.fbRangoDias.get("priceMax").value;
    this.allItems = this.products.filter((item: Product) => {
      return item.PV3 >= this.priceMin && item.PV3 <= this.priceMax;
    });
  }

  public updatePriceFiltersMax() {
    this.priceMin = this.fbRangoDias.get("priceMin").value;
    this.priceMax = this.fbRangoDias.get("priceMax").value;
    this.allItems = this.products.filter((item: Product) => {
      return item.PV3 >= this.priceMin && item.PV3 <= this.priceMax;
    });
  }

  onBrendsChanged(newBrend) {
    this.marcaParam = newBrend.value;
    this.router.navigate(
      [
        "/home/products/",
        this.categoryParam,
        this.criterioParam,
        this.gamerParam,
        this.marcaParam,
        this.procesadorParam,
        this.almacenamientoParam,
        1,
      ],
      {
        queryParams: { Tienda: this.Filial },
      }
    );
  }
  changeParam(param, i) {
    switch (i) {
      case 1:
        this.gamerParam = param.value == "" ? "0" : param.value;
        this.router.navigate(
          [
            "/home/products/",
            this.categoryParam,
            this.criterioParam,
            this.gamerParam,
            this.marcaParam,
            this.procesadorParam,
            this.almacenamientoParam,
            1,
          ],
          {
            queryParams: { Tienda: this.Filial },
          }
        );
        break;
      case 2:
        this.procesadorParam = param.value == "" ? "0" : param.value;
        this.router.navigate(
          [
            "/home/products/",
            this.categoryParam,
            this.criterioParam,
            this.gamerParam,
            this.marcaParam,
            this.procesadorParam,
            this.almacenamientoParam,
            1,
          ],
          {
            queryParams: { Tienda: this.Filial },
          }
        );
        break;
      case 3:
        this.almacenamientoParam = param.value == "" ? "0" : param.value;
        this.router.navigate(
          [
            "/home/products/",
            this.categoryParam,
            this.criterioParam,
            this.gamerParam,
            this.marcaParam,
            this.procesadorParam,
            this.almacenamientoParam,
            1,
          ],
          {
            queryParams: { Tienda: this.Filial },
          }
        );
        break;
      case 4:
        this.categoryParam = param.value == "" ? "0" : param.value;
        this.router.navigate(
          [
            "/home/products/",
            this.categoryParam,
            this.criterioParam,
            this.gamerParam,
            this.marcaParam,
            this.procesadorParam,
            this.almacenamientoParam,
            1,
          ],
          {
            queryParams: { Tienda: this.Filial },
          }
        );
        break;
      case 5:
        this.Filial = param.value == "" ? "" : param.value;
        this.router.navigate(
          [
            "/home/products/",
            this.categoryParam,
            this.criterioParam,
            this.gamerParam,
            this.marcaParam,
            this.procesadorParam,
            this.almacenamientoParam,
            1,
          ],
          {
            queryParams: { Tienda: this.Filial },
          }
        );
        break;
    }
    // this.cargarInfoProduct();
  }
  changeNewParam(param, i) {
    switch (i) {
      case 1:
        this.paramNomItem.param1 = param.value;
        break;
      case 2:
        this.paramNomItem.param2 = param.value;
        break;
      case 3:
        this.paramNomItem.param3 = param.value;
        break;
    }
    let criterio =
      this.paramNomItem.param1 +
      " " +
      this.paramNomItem.param2 +
      " " +
      this.paramNomItem.param3;
    this.criterioParam = criterio.trim();
    this.router.navigate(
      [
        "/home/products/",
        this.categoryParam,
        this.criterioParam,
        this.gamerParam,
        this.marcaParam,
        this.procesadorParam,
        this.almacenamientoParam,
        1,
      ],
      {
        queryParams: { Tienda: this.Filial },
      }
    );
  }
  onBrendsChangedProc(param) {
    this.mensajeResultado = "Cargando Resultados";
    this.allItems.splice(0, this.allItems.length);
    this.products.splice(0, this.products.length);
    this.productService.getProductbyparam(param).subscribe((Product) => {
      this.allItems = Product;
      this.products = Product.slice(0.8);
      this.obtenerPrecioMaximo();
    });
    this.scrollTop();
    setTimeout(() => {
      if (this.allItems.length == 0) {
        this.mensajeResultado = "Sin Resultados";
        this.spinner.hide();
      }
    }, 3000);
  }
  obtenerPrecioMaximo() {
    let maxPrice = 0;
    let minPrice = 0;
    let precios: any = [];
    this.products.forEach((x) => {
      if (x.PV3 == 0) {
        x.PV3 = x.PV2;
      }
      let i = precios.findIndex((x) => x == x.PV3);
      if (i == -1) {
        precios.push(x.PV3);
      }
    });
    maxPrice = Math.max(...precios);
    this.priceMax = maxPrice;
    this.priceFin = maxPrice;
    minPrice = Math.min(...precios);
    this.priceMin = minPrice;
    this.priceIni = minPrice;
    this.fbRangoDias.get("priceMax").setValue(this.priceMax);
    this.fbRangoDias.get("priceMin").setValue(this.priceMin);
  }
  esGamer(e: any) {
    this.estGamer = e.checked;
  }
  async obtenerMarcas(param) {
    return await this.productService
      .getMarcas(param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  async obtenerEnum(param) {
    return await this.ecomService
      .getParam(environment.apiUrlAdm,constApi.ENUMTIPO, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  async obtenerProductos(param) {
    return await this.productService
      .getParam(constApi.ITEMSEC_LIST, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  async obtenerCategorias() {
    return await this.enumService
      .getMenu("cat")
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  async obtenerCatalogo(param) {
    return await this.productService
      .getParam(constApi.ITEMSECCAT, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  async obtenerFiliales() {
    return await this.productService
      .getParam(constApi.FILIALISTEC, [])
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  cargarArrayMarcas(res: any) {
    let seleccionado: boolean = false;
    this.brands = [];
    this.brands.push({
      idMarca: 0,
      Marca: "TODAS",
      Abrev: "",
      MarcaURL: "",
      Cant: 0,
      checked: this.marca == "TODAS" ? true : false,
    });
    res.forEach((x) => {
      if (x.Marca == this.marca && this.marca != "TODAS") {
        seleccionado = true;
        this.brands.push({
          idMarca: 0,
          Marca: x.Marca,
          Abrev: "",
          MarcaURL: "",
          Cant: 0,
          checked: seleccionado,
        });
      } else {
        seleccionado = false;
        this.brands.push({
          idMarca: 0,
          Marca: x.Marca,
          Abrev: "",
          MarcaURL: "",
          Cant: 0,
          checked: seleccionado,
        });
      }
    });
  }
  scrollTop() {
    this.spinner.show();
    var anchoVentana = window.innerWidth;
    if (anchoVentana <= 500) {
      if (document.getElementById("divItems") != null) {
        setTimeout(() => {
          document.getElementById("divItems").scrollIntoView(true);
          this.spinner.hide();
        }, 1000);
      }
    } else {
      if (document.getElementById("divItems") != null) {
        setTimeout(() => {
          document.getElementById("divItems").scrollIntoView(true);
          this.spinner.hide();
        }, 1000);
      }
    }
  }
  cleanFilter() {
    this.router.navigate(
      ["/home/products/", this.categoryParam, 0, 0, "TODAS", 0, 0, 1],
      {
        queryParams: { Tienda: this.Filial },
      }
    );
  }
}
